module.exports = __webpack_public_path__ + "static/media/02-02.97e42d71.png";